import c from '../common';

export default{
    "tmr": "Tomorrow",
    "booking": "Total Bookings",

    "untilToday":"Until Today",

    "NA": c.NA.en,

    "QTY":"qty",

    "IN_STORE_REDEEM":"Store Redemption",
    "DELIVERY_REDEEM":"Delivery",
};